import React from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { PlayerPromoSendingModeEnum } from "@api-types/user/AccountActivationRequestDto";
import { ErrorMessage, RequiredMark } from "@components/inputs/shared";

export default function OnboardingRegistrationPromotion() {
	const { t } = useTranslation("registration");

	return (
		<div className="form__group u-mar--bottom--reset">
			<div className="label label--strong u-type--sml">
				{t("NEWSLETTER_LABEL")}
				<RequiredMark required />
			</div>

			<ErrorMessage name="playerPromoSendingMode" />

			<RadioInput
				id="newsletterCheckboxChecked"
				label="registration:NEWSLETTER_CHECKED"
				checkboxClassName="u-mar--bottom--xtny"
				value={PlayerPromoSendingModeEnum.enabled}
			/>
			<RadioInput
				id="newsletterCheckboxUnchecked"
				label="registration:NEWSLETTER_UNCHECKED"
				value={PlayerPromoSendingModeEnum.disabled}
			/>
		</div>
	);
}

function RadioInput(props: {
	id: string;
	label: string;
	checkboxClassName?: string;
	value: PlayerPromoSendingModeEnum;
}) {
	const { id, label, value, checkboxClassName } = props;

	const { t } = useTranslation();
	const { register } = useFormContext();

	const field = register("playerPromoSendingMode", {
		required: {
			value: true,
			message: "COMMON.REQUIRED_FIELD",
		},
	});

	return (
		<div
			className={
				"input--radio input--radio--sml" +
				(checkboxClassName ? " " + checkboxClassName : "")
			}
		>
			<input
				id={id}
				className="input--radio__box input--radio--sml__box"
				type="radio"
				value={value}
				{...field}
			/>
			<label
				htmlFor={id}
				className="input--radio__label input--radio--sml__label"
			>
				{t(label)}
			</label>
		</div>
	);
}
